import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { AddCustomerContactInformationResponseDto } from "../models/client/addclient/AddCustomerContactInformationResponseDto";
import { UpdateCustomerContactInformationResponseDto } from "../models/client/addclient/UpdateCustomerContactInformationResponseDto";
import { AddContactsDto } from "../models/client/addclient/addContactsDto";
import { AddCustomerAddressRequestDto } from "../models/client/details/addCustomerAddressRequestDto";
import { AddCustomerAddressResponseDto } from "../models/client/details/addCustomerAddressResponseDto";
import { GenericResponseDto } from "../models/generic-response.dto";

@Injectable({
  providedIn: "root",
})
export class AddContactInformationService {
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";
  constructor(private _http: HttpClient) {}

  addContactInformationData(
    payload: AddContactsDto
  ): Observable<
    GenericResponseDto<AddCustomerContactInformationResponseDto[]>
  > {
    return this._http.post<
      GenericResponseDto<AddCustomerContactInformationResponseDto[]>
    >(this.clientManagementBaseURL + "/AddCustomerContact", payload);
  }

  updateContactInformationData(
    payload: AddContactsDto
  ): Observable<
    GenericResponseDto<UpdateCustomerContactInformationResponseDto[]>
  > {
    return this._http.post<
      GenericResponseDto<UpdateCustomerContactInformationResponseDto[]>
    >(this.clientManagementBaseURL + "/UpdateCustomerContact", payload);
  }

  upsertContactInformationData(
    payload: AddContactsDto
  ): Observable<
    GenericResponseDto<UpdateCustomerContactInformationResponseDto[]>
  > {
    return this._http.post<
      GenericResponseDto<UpdateCustomerContactInformationResponseDto[]>
    >(this.clientManagementBaseURL + "/UpsertCustomerContact", payload);
  }

  addAddressInformationData(
    payload: AddCustomerAddressRequestDto
  ): Observable<GenericResponseDto<AddCustomerAddressResponseDto>> {
    return this._http.post<GenericResponseDto<AddCustomerAddressResponseDto>>(
      this.clientManagementBaseURL + "/AddCustomerAddress",
      payload
    );
  }

  updateAddressInformationData(
    payload: AddCustomerAddressRequestDto
  ): Observable<GenericResponseDto<AddCustomerAddressResponseDto>> {
    return this._http.post<GenericResponseDto<AddCustomerAddressResponseDto>>(
      this.clientManagementBaseURL + "/UpdateCustomerAddress",
      payload
    );
  }
}
